// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__tnpkt","icon":"style_icon__9mkxK","title":"style_title__oR-c+"};